<template>
  <div class="row">
    <div class="col" v-show="showRequestMusic">
      <div>
        <div class="voto-sucesso" v-if="sent">
          <p><i class="fas fa-check"></i> Pedido enviado com sucesso! </p>
        </div>
        <div class="" v-else="sent">
          <h2>Peça sua música</h2>
          <form id="peca-sua-musica">
            <label>
              Nome <input type="text" v-model="music.name">
            </label>
            <label>
              Email <input type="email" v-model="music.email">
            </label>
            <label>
              Cidade <input type="text" v-model="music.city">
            </label>
            <label>
              Estado <input type="text" v-model="music.state">
            </label>
            <label class="ultimo">
              Nome da Música <textarea v-model="music.message"></textarea>
            </label>
            <div>
              <vue-recaptcha ref="recaptcha" @verify="onVerify" @expired="onExpired" :sitekey="sitekey" class="captcha">
              </vue-recaptcha>
              <button type="button" @click="handleSubmit()"> Enviar</button>
            </div>
          </form>
        </div>
      </div>

    </div>
    <div class="col" v-show="showPoll">
      <h2>Enquete</h2>
      <div v-if="showPollResults">
        <div class="enquete result">
          <p>Resultado parcial: {{ pollQuestion }} </p>
          <div class="percentage">
            <div class="progress" v-for="option in pollOptions">
              <div role="progressbar" :aria-valuenow="option.percentage" aria-valuemin="0" aria-valuemax="100"
                   class="progress-bar"
                   :style="{width: option.percentage}">
                {{ getOptionLabel(option) }}
              </div>
            </div>
          </div>
          <a @click.prevent="closePollResult()">Voltar</a>
        </div>
      </div>
      <div v-if="!showPollResults">
        <div class="voto-sucesso" v-if="pollSent">
          <p><i class="fas fa-check"></i> Seu voto foi computado com sucesso</p>
          <p><a @click.prevent="openPollResult()">Ver resultados</a></p>
        </div>
        <div class="" v-if="!pollSent">
          <form id="enquete" @submit.prevent="handlePollSubmit" v-if="pollQuestion">
            <div class="campos">
              <p>{{ pollQuestion }}</p>
              <label v-for="option in pollOptions">
                <input type="radio" name="enquete" :value="option.value" v-model="pollOption" required>
                {{ option.label }}
              </label>
            </div>

            <div class="botoes">
              <input type="submit" value="Votar">
              <a @click.prevent="openPollResult()">Ver resultados</a>
            </div>

          </form>
          <p v-else="pollQuestion">Nenhuma enquete ativa no momento</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import services from '../service/api'
  import VueRecaptcha from 'vue-recaptcha';


  export default {
    name: "RequestMusic",
    props: [],
    components: {
      VueRecaptcha
    },
    data() {
      return {
        sitekey: window.config.RECAPTCHA_KEY,
        verified: false,
        showPoll: window.config.site.showPoll,
        showRequestMusic: window.config.site.showRequestMusic,
        music: {
          name: '',
          email: '',
          city: '',
          state: '',
          message: ''
        },
        sent: false,
        pollId: null,
        pollOption: null,
        pollSent: false,
        pollQuestion: '',
        pollOptions: [],
        showPollResults: false,
        captcha: false
      }
    },
    mounted() {
      this.getPoll();
    },
    methods: {
      getOptionLabel(option) {
        let label = option.label;
        if(!option.percent){
          label = label + ' (0%)';
          return label;
        }
        label = label + ' (' + option.percent + '%)';
        return label;
      },
      getPoll() {
        let self = this;
        services.get('current-poll').then(function (response) {
          if (parseInt(response.status) === 200) {
            self.pollId = response.data.result.data.id;
            self.pollQuestion = response.data.result.data.answer;
            self.pollOptions = response.data.result.data.options;
            if (response.data.result.data.length <= 0) {
              //
            }
          }
        }).catch(function (err) {
          console.error(err);
        })
      },
      handleSubmit: function () {
        let self = this;
        event.preventDefault();
        console.log("Submit clicked");
        if (!this.music.name) {
          alert(" Nome obrigatório ")
          return false;
        }
        if (!this.music.email) {
          alert(" Email obrigatório ")
          return false;
        }
        if (!this.music.city) {
          alert(" Cidade obrigatório ")
          return false;
        }
        if (!this.music.state) {
          alert(" Estado obrigatório ")
          return false;
        }
        if (!this.music.message) {
          alert(" Mensagem obrigatória ")
          return false;
        }
        if (!this.captcha) {
          alert("captcha obrigatória");
          return false;
        }

        services.post('request-music', this.music).then(function (response) {
          self.resetRecaptcha();
          self.sent = true;
        }).catch(function (err) {
          console.error(err);
          alert("Ocorreu um problema ao enviar seu pedido.")
          self.sent = false;
        });
      },
      handlePollSubmit(token) {
        let self = this;
        if (token) {
          services.post('polling', {pollId: this.pollOption}).then(function (response) {
            self.pollSent = true;
            self.getPoll();
          }).catch(function (err) {
            console.error(err);
            alert("Ocorreu um problema ao computar o seu voto.")
            self.pollSent = false;
          });
        }
      },
      onSubmit: function () {
        this.$refs.recaptcha.execute();
      },
      onVerify: function (response) {
        this.captcha = response;
      },
      onExpired: function () {
        console.log('Expired')
      },
      resetRecaptcha() {
        this.$refs.recaptcha.reset() // Direct call reset method
      },
      openPollResult() {
        this.showPollResults = true;
      },
      closePollResult() {
        this.showPollResults = false;
      }
    }
  }
</script>

<style scoped>
  .grecaptcha-badge {
    visibility: hidden !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/RequestMusic.vue